module.exports = __webpack_public_path__ + "static/media/theme-icons.234469a1.svg";